import { SVGProps, Ref, forwardRef } from 'react';

export const ThumbUpFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M6.198 1.883C6.28.863 7.376.187 8.34.647c1.012.483 1.363 1.475 1.363 2.583v2.045h3.069c2.322.072 2.986.957 2.642 3.405l-.48 3.41c-.356 2.54-1.325 3.398-3.867 3.41H5.099V4.996h-.071C5.712 3.973 6.107 3 6.198 1.883"
                    fill="currentColor"
                />
                <path
                    d="M3.699 5.961C1.31 6.06.5 7.013.5 9.59v2.273c0 2.576.811 3.53 3.199 3.628z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ThumbUpFilledSize16Glyph.displayName = 'ThumbUpFilledSize16Glyph';
